export const TUPA25FeatureFlags = {
    enabledFeatures: [],
    initialized: false,

    init(features) {
        if (Array.isArray(features)) {
            this.enabledFeatures = features;
        } else if (features === undefined || features === null) {
            this.loadFromCookie();
        } else {
            console.warn('Invalid features parameter passed to init:', features);
            this.loadFromCookie();
        }
        this.initialized = true;
    },

    loadFromCookie() {
        try {
            const cookieName = 'tupa25_features';
            const cookieValue = commonUtils.getCookie(cookieName); // Ensure commonUtils is defined

            if (cookieValue) {
                this.enabledFeatures = cookieValue.split(',').filter(Boolean);
            }
        } catch (e) {
            console.error('Error loading TUPA25 features from cookie:', e);
            this.enabledFeatures = [];
        }
    },

    isEnabled(feature) {
        if (!this.initialized) {
            this.init([]);
        }
        return this.enabledFeatures.includes(feature);
    },

    getEnabledFeatures() {
        if (!this.initialized) {
            this.init([]);
        }
        return [...this.enabledFeatures];
    },
};

$(function() {
    const features = window.TUPA25_FEATURES || [];
    TUPA25FeatureFlags.init(features);

    const enabledFeatures = TUPA25FeatureFlags.getEnabledFeatures();
    console.log('Enabled features:', enabledFeatures);

    if (typeof TUPA25FeatureFlags !== 'undefined' && TUPA25FeatureFlags) {
        // Example for pricing tool
        if (TUPA25FeatureFlags.isEnabled('pricing-tool')) {
            console.log('Pricing tool feature is enabled');
            initPricingTool();
        }

        // Example for statistics visualization
        if (TUPA25FeatureFlags.isEnabled('statistics-visualization')) {
            console.log('Statistics visualization feature is enabled');
            initStatisticsVisualization();
        }
    } else {
        console.warn('TUPA25 feature flag system not available');
    }
});

function initPricingTool() {
    // Initialize the pricing tool
    console.log('Initializing pricing tool...');
    // Add your pricing tool initialization code here
}

function initStatisticsVisualization() {
    // Initialize the statistics visualization
    console.log('Initializing statistics visualization...');
    // Add your statistics visualization initialization code here
}
